import React, { useRef, useState } from "react";
import { useClickOutside } from "./useClickOutside";
import './scss/worktualdropdown.scss';
import ReactDOM from "react-dom";

interface Option {
  label: string | React.ReactNode;
  value: string | number;
}

interface SelectProps {
  options: Option[];
  // onChange: any;
  onChange(value: Option): void;
  defaultValue?: Option;
  children: React.ReactNode;
  placement?: string;

}

const WorktualDropdown: React.FC<SelectProps> = ({
  options,
  onChange,
  defaultValue,
  children,
  placement = ''
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState<Option | null>(defaultValue || null);
  const [highlightedIndex, setHighlightedIndex] = useState<number>(-1);
  const [position, setPosition] = useState({ top: 0, left: 0, elemWidth: 0 });
  const optionRef = useRef<HTMLDivElement>(null);
  
  const dropRef = useRef<HTMLDivElement>(null);
  // useClickOutside([dropRef, optionRef], () => setIsOpen(false));


  const toggleFloating = () => {
    if (!isOpen && dropRef.current) {
      const rect = dropRef.current.getBoundingClientRect();
      setPosition({
        top: rect.bottom + window.scrollY + 8,
        left: rect.left + window.scrollX,
        elemWidth: rect.width
      });
    }
    setIsOpen(!isOpen);
  };

  const handleSelect = (option: Option) => {
    setSelected(option);
    onChange(option);
    setIsOpen(false);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === "ArrowDown") {
      setHighlightedIndex((prev) => Math.min(prev + 1, options.length - 1));
    } else if (e.key === "ArrowUp") {
      setHighlightedIndex((prev) => Math.max(prev - 1, 0));
    } else if (e.key === "Enter" && highlightedIndex !== -1) {
      handleSelect(options[highlightedIndex]);
    } else if (e.key === "Escape") {
      setIsOpen(false);
    }
  };

  return (
    <div ref={dropRef}  className="dropdowncontainer" tabIndex={0} onKeyDown={handleKeyDown}>
      <div onClick={() => { setIsOpen((prev) => !prev); toggleFloating() }} className={`dropshow`}>
        {children}
      </div>

      {isOpen && <div ref={optionRef} className="dropoptcontainer" style={{right:`${placement === 'left' ? 0 : 'auto'}`}}>
          <ul>
            {
              options.length > 0 ? <>
                {options.map((option, index) => (
                  <li
                    key={option.value}
                    onClick={() => handleSelect(option)}
                    className={`${highlightedIndex === index ? "drophightlightopt" : ""}`}
                  >
                    {option.label}
                  </li>
                ))}
              </>
                :
                <li className="dropnooptionsinselect">No options found</li>
            }
          </ul>
        </div>
      }
    </div>
  );
};

export default WorktualDropdown;
